export const initialState = {
  event: null,
  timestamp: null,
};

export const listeners = (state = initialState, action) => {
  const { type, ...data } = action;
  switch (type) {
    case "listeners/event": {
      const listeners = {
        ...state,
        event: action.event,
        timestamp: new Date().getTime(),
      };
      return {
        ...listeners,
      };
    }
    default:
      return state;
  }
};
